import { render, staticRenderFns } from "./LoadingTrail.vue?vue&type=template&id=788154a1"
import script from "./LoadingTrail.vue?vue&type=script&lang=js"
export * from "./LoadingTrail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports